export type HttpFailureLogLevel = 'error' | 'info';

export interface HttpFailureClassification {
  level: HttpFailureLogLevel;
  reason: string;
}

export function classifyHttpFailure(status: number | undefined): HttpFailureClassification {
  if (typeof status !== 'number' || Number.isNaN(status)) return { level: 'info', reason: 'no_status' };
  if (status === 0) return { level: 'info', reason: 'transport_unavailable' };
  if (status === 401) return { level: 'info', reason: 'unauthenticated' };
  if (status === 403) return { level: 'info', reason: 'unauthorized' };
  if (status >= 400 && status < 500) return { level: 'info', reason: 'client_error' };
  if (status >= 500 && status < 600) return { level: 'error', reason: 'server_error' };

  return { level: 'error', reason: 'unclassified' };
}
